import React from 'react';

const Header = () => {
    return (
        <div className="header">
            <h1>Good Thoughts 4U</h1>
            <p>Write something good for your day!</p>
        </div>
    )
}

export default Header;